import { render } from "./findPw.vue?vue&type=template&id=0b97077d"
import script from "./findPw.vue?vue&type=script&lang=js"
export * from "./findPw.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__